export const brl = (v) => (v == null ? "—" : Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
export const num = (v, d = 0) => (v == null ? "—" : Number(v).toLocaleString("pt-BR", { maximumFractionDigits: d, minimumFractionDigits: d }));
export const pct = (v) => (v == null ? "—" : `${num(v, 2)}%`);
export const dt = (s) => (s ? new Date(s).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "—");
export const day = (s) => (s ? new Date(s).toLocaleDateString("pt-BR") : "—");
export const delta = (cur, prev) => (prev ? ((cur - prev) / prev) * 100 : null);

export const STATUS_LABEL = {
  trial: "Teste grátis", active: "Ativa", past_due: "Pagamento pendente", cancelled: "Cancelada",
  expired: "Expirada", suspended: "Suspensa",
};
export const OBJECTIVES = [
  { id: "calls", label: "Gerar ligações" }, { id: "messages", label: "Gerar mensagens" },
  { id: "leads", label: "Gerar leads" }, { id: "sales", label: "Gerar vendas" },
  { id: "traffic", label: "Gerar tráfego" }, { id: "awareness", label: "Reconhecimento" },
];
export const MATCH_LABEL = { BROAD: "Ampla", PHRASE: "Frase", EXACT: "Exata" };
